import { apiCall } from './gqlClient';

const GETBROADCASTMESSAGES_QUERY = `
  query getBroadcastMessages {
    getBroadcastMessages
    {
      id
			subject
			body
			publishDate
      ...fragments
    }
  }`;

export const getBroadcastMessagesApiCall = async (fragments = null) => apiCall({ query: GETBROADCASTMESSAGES_QUERY, variables: {}, fragments });

const BROADCASTMESSAGEBYPROVIDER_QUERY = `
  mutation broadcastMessageByProvider($subject: String!, $message: String!) {
    broadcastMessageByProvider(subject: $subject, message: $message)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const broadcastMessageByProviderApiCall = async ({subject, message}, fragments = null) => apiCall({ query: BROADCASTMESSAGEBYPROVIDER_QUERY, variables: {subject, message}, fragments });
